export const SET_LOADING_DATA = '@clientChecklist/SET_LOADING_DATA';
export const SET_LOADING_SEND = '@clientChecklist/SET_LOADING_SEND';
export const SET_LOADING_MODAL_QUESTION = '@clientChecklist/SET_LOADING_MODAL_QUESTION';

export const GET_LIST_ALL_QUESTIONS_REQUEST = '@clientChecklist/GET_LIST_ALL_QUESTIONS_REQUEST';
export const GET_LIST_ALL_QUESTIONS_SUCCESS = '@clientChecklist/GET_LIST_ALL_QUESTIONS_SUCCESS';

export const GET_BY_ID_REQUEST = '@clientChecklist/GET_BY_ID_REQUEST';
export const GET_BY_ID_SUCCESS = '@clientChecklist/GET_BY_ID_SUCCESS';

export const EDIT_ITEM = '@clientChecklist/EDIT_ITEM';
export const DELETE_ITEM = '@clientChecklist/DELETE_ITEM';

export const SAVE_CLIENT_CHECKLIST_REQUEST = '@clientChecklist/SAVE_CLIENT_CHECKLIST_REQUEST';
export const SAVE_CLIENT_CHECKLIST_SUCCESS = '@clientChecklist/SAVE_CLIENT_CHECKLIST_SUCCESS';

export const SET_PAGE = '@clientChecklist/SET_PAGE';
export const SET_ROWS_COUNT = '@clientChecklist/SET_ROWS_COUNT';
export const SET_ROWS_PER_PAGE = '@clientChecklist/SET_ROWS_PER_PAGE';
export const SET_ORDER = '@clientChecklist/SET_ORDER';
export const SET_ORDERBY = '@clientChecklist/SET_ORDERBY';

export const SEARCH = '@clientChecklist/SEARCH';
